export default __webpack_public_path__ + "static/media/Rubik-Black.37238404.woff2";